import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";
import { useUser } from "~/Context/userContext";

const TrackAddPlaylist = ({ track }) => {
  let { state, dispatch } = useUser();
  const [ready, setReady] = useState(false);
  let history = useHistory();

  useEffect(() => {
    if (track.id && state.loaded) {
      setReady(true);
      return;
    }
  }, [state]);

  const handleLinkClick = () => {
    window.gtag("event", `click`, {
      playlist_add: `${track.artist} - ${track.title}`,
    });

    if (ready && !state.loggedin) {
      dispatch({ type: "signin_show_playlist" });
    } else {
      history.push(`/playlist/add/${track.id}`);
    }
  };

  return ready ? (
    <Link onClick={() => handleLinkClick()} title="Add track to a Playlist">
      <div class="addToPlaylist">
        <FontAwesomeIcon icon={faMusic} style={{ fontSize: 20, marginRight: 2 }} />
        <span>Add to Playlist</span>
        <span className="plus">+</span>
      </div>
    </Link>
  ) : null;
};

export default TrackAddPlaylist;
